module.exports = __webpack_public_path__ + "static/media/main-logo.2b4b216e.svg";